import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const HeroContainer = styled(motion.div)`
  width: 100%;
  height: 100%;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
`;

const PictureContainer = styled.picture`
  width: 100%;
  height: 100%;
  display: block;
`;

const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
`;

const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(99, 102, 241, 0.1) 0%,
    rgba(139, 92, 246, 0.05) 50%,
    rgba(99, 102, 241, 0.1) 100%
  );
  border-radius: 20px;
  pointer-events: none;
`;

const AnimatedHero = () => {
  return (
    <HeroContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <PictureContainer>
        {/* WebP格式：更好的压缩率和质量 */}
        <source srcSet="/images/hero/hero-main.webp" type="image/webp" />
        {/* PNG格式：作为fallback，兼容不支持WebP的浏览器 */}
        <HeroImage
          src="/images/hero/hero-main.png"
          alt="职唛AI智能求职平台演示"
          fetchpriority="high"
          decoding="async"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
      </PictureContainer>
      <ImageOverlay />
      
      {/* 备用内容，当图片加载失败时显示 */}
      <FallbackContent style={{ display: 'none' }}>
        <FallbackTitle>AI驱动的智能求职平台</FallbackTitle>
        <FallbackSubtitle>实时对话式AI指导，个性化简历优化，模拟面试训练</FallbackSubtitle>
      </FallbackContent>
    </HeroContainer>
  );
};

const FallbackContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #6366F1, #8B5CF6);
  color: white;
  text-align: center;
  padding: 2rem;
  border-radius: 20px;
`;

const FallbackTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: white;
`;

const FallbackSubtitle = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
`;

export default AnimatedHero; 
